/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/student.scss';
import Tab from '../../component/Inc/Tab';
import Paging from '../../component/Inc/Paging';
import PopClassPlan from './_PopClassPlan';
function ClassPlan() {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '국어', value: 0},
    {title: '영어', value: 1},
    {title: '수학', value: 2},
    {title: '과탐', value: 3},
    {title: '사탐', value: 4},
    {title: '논술', value: 5},
    {title: '면접', value: 6},
    {title: '생디', value: 7},
    {title: '미작성', type: ' red', value: 8},
    {title: '내 계획서', value: 9}
  ];
  const [modalClassPlan, setModalClassPlan] = useState(false);
  return (
    <main className="com_container p_class_plan">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu1_14">수업 계획서</h2>
          <div className="com_btn_wrap">
            <button onClick={() => setModalClassPlan(true)} className="com_btn orange s btn_plus">
              수업계획서 등록
            </button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력" className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="4%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>등록일</th>
                  <th>첫 수업일</th>
                  <th>등록자 (교사)</th>
                  <th>학생명</th>
                  <th>과목</th>
                  <th>과목 상세</th>
                  <th>교사</th>
                  <th>담임</th>
                  <th>멘토</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>11</td>
                  <td className="td_date td_red">미등록</td>
                  <td className="td_date">2022.08.25 12:30</td>
                  <td>
                    <button className="btn_link">가길동102</button>
                  </td>
                  <td>
                    <button className="btn_link">가학생102</button>
                  </td>
                  <td>수학</td>
                  <td>튼튼수학</td>
                  <td>
                    <button className="btn_link">가교사102</button>
                  </td>
                  <td>
                    <button className="btn_link">가담임102</button>
                  </td>
                  <td>
                    <button className="btn_link">가학생102</button>
                  </td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{10 - idx}</td>
                      <td className="td_date">2022.08.25 12:30</td>
                      <td className="td_date">2022.08.25 12:30</td>
                      <td>
                        <button className="btn_link">가길동102</button>
                      </td>
                      <td>
                        <button className="btn_link">가학생102</button>
                      </td>
                      <td>수학</td>
                      <td>튼튼수학</td>
                      <td>
                        <button className="btn_link">가교사102</button>
                      </td>
                      <td>
                        <button className="btn_link">가담임102</button>
                      </td>
                      <td>
                        <button className="btn_link">가학생102</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          {/* 상세보기 */}
          <section className="box">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_info">
              <p className="name">김교사104</p>
              <span className="dot" />
              <p className="date">2023.05.20 11:30</p>
              <button className="btn_edit" />
            </div>
            <div className="com_board_box">
              <div className="tit">수업정보</div>
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <button className="name">홍학생102 </button>
                    <span className="desc dot">수업일 : 2023, 05, 16 15:30</span>
                  </span>
                </div>
                <button type="button" className="icon_arrow_down" onClick={() => {}}></button>
              </div>
            </div>
            <div className="check">
              <input type="checkbox" id="chk01" className="com_chk" />
              <label htmlFor="chk01">전화 상담 여부</label>
            </div>
            <div className="com_board_box">
              <div className="board_item">
                상담 대상 : 김학생 부모 <br />
                상담 메모
              </div>
              <div className="board_item memo">
                수업계획을 이렇게 짜보았습니다. <br />
                1회
                <br />
                2회
              </div>
              <hr className="com_divider" />
            </div>
            <div className="com_comment_wrap type_board short">
              <ul className="comment_list">
                {[1, 2].map((i, idx) => {
                  return (
                    <li className="item" key={idx}>
                      <div className="info">
                        <p className="name">홍길동104</p>
                        <span className="dot" />
                        <p className="date">2023.05.20 11:30</p>
                        <div className="com_btn_wrap">
                          <button className="btn_edit"></button>
                          <button className="btn_delete"></button>
                        </div>
                      </div>
                      <p className="txt">
                        축하드려요~!축하드려요~!축하드려요~!축하드려요~!축하드려요~!축하드려요~!축하드려요~!
                        <br />
                        축하드려요~!
                      </p>
                    </li>
                  );
                })}
              </ul>
              <div className="comment_input">
                <textarea type="text" className="textarea" placeholder="댓글을 입력해주세요" />
                <button className="com_btn gray l">등록</button>
              </div>
            </div>
          </section>
        </section>
      </div>
      <PopClassPlan open={modalClassPlan} close={() => setModalClassPlan(false)} />
    </main>
  );
}

export default ClassPlan;
